import { useState } from 'react';
import { api, ApiError } from '../api.ts';
import { Field } from '../ui.tsx';

/** Entrada e cadastro. O primeiro cadastro já cria um workspace real e um de demonstração. */
export function LoginPage({ onAuthenticated }: { onAuthenticated: () => void }): JSX.Element {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (mode === 'login') {
        await api('/api/auth/login', { body: { email, password }, workspace: null });
      } else {
        await api('/api/auth/register', {
          body: { email, password, name, workspaceName: workspaceName || undefined },
          workspace: null,
        });
      }
      onAuthenticated();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Não foi possível concluir. Tente novamente.');
      if (err instanceof ApiError && err.code === 'FORBIDDEN') setMode('login');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <div className="auth-card">
        <div className="brand" style={{ padding: 0, marginBottom: 20 }}>
          <span className="brand-mark" />
          <div>
            <div className="brand-name">Orbs</div>
            <div className="brand-sub">Vídeo interativo</div>
          </div>
        </div>

        <h1 className="page-title" style={{ fontSize: 19 }}>
          {mode === 'login' ? 'Entrar na plataforma' : 'Criar sua conta'}
        </h1>
        <p className="page-sub" style={{ marginBottom: 20 }}>
          {mode === 'login'
            ? 'Acesse a biblioteca, os players e os relatórios.'
            : 'Você começa com um workspace próprio e outro de demonstração com dados fictícios.'}
        </p>

        <form onSubmit={submit}>
          {mode === 'register' && (
            <Field label="Seu nome" id="name">
              <input id="name" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} autoComplete="name" />
            </Field>
          )}
          <Field label="E-mail" id="email">
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </Field>
          <Field
            label="Senha"
            id="password"
            hint={mode === 'register' ? 'Mínimo de 8 caracteres, com letras e números.' : undefined}
          >
            <input
              id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required minLength={mode === 'register' ? 8 : 1}
              autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
            />
          </Field>
          {mode === 'register' && (
            <Field label="Nome do workspace" id="ws" hint="Pode ser o nome da sua empresa ou do projeto.">
              <input id="ws" value={workspaceName} onChange={(e) => setWorkspaceName(e.target.value)} placeholder="Meu Studio" />
            </Field>
          )}

          {error && <div className="alert error" style={{ marginBottom: 14 }}>{error}</div>}

          <button type="submit" className="btn block" disabled={busy}>
            {busy ? <span className="spinner-inline" /> : null}
            {mode === 'login' ? 'Entrar' : 'Criar conta'}
          </button>
        </form>

        <p style={{ marginTop: 18, marginBottom: 0, fontSize: 13, color: 'var(--text-3)', textAlign: 'center' }}>
          {mode === 'login' ? 'Ainda não tem conta? ' : 'Já tem conta? '}
          <button
            type="button"
            className="btn ghost small"
            style={{ marginLeft: 4 }}
            onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(null); }}
          >
            {mode === 'login' ? 'Cadastrar' : 'Entrar'}
          </button>
        </p>
      </div>
    </div>
  );
}
